import * as XLSX from "xlsx";

export type Column<T> = {
    id: keyof T;
    label: string;
};

export type VisibleColumns<T> = Partial<Record<keyof T, boolean>>;

export type ExportToExcelArgs<T> = {
    data: T[];
    columns: Column<T>[];
    visibleColumns?: VisibleColumns<T>;  
    fileName?: string;
};

export function exportToExcel<T>({
    data,
    columns,
    visibleColumns = {},             
    fileName = "Report.xlsx",
}: ExportToExcelArgs<T>): void {
    if (!data || data.length === 0) {
        console.warn("No data to export");
        return;
    }

    const shownColumns = columns.filter((col) => visibleColumns[col.id] !== false);

    if (shownColumns.length === 0) {
        console.warn("No visible columns to export");
        return;
    }

    const exportRows: Record<string, unknown>[] = data.map((row) => {
        const obj: Record<string, unknown> = {};
        shownColumns.forEach((col) => {
            obj[col.label] = row[col.id] ?? "";
        });
        return obj;
    });

    const ws = XLSX.utils.json_to_sheet(exportRows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, fileName);
}